import React from "react";
import Message from "@/model/interface/Message";
import { MessageSquare, Image } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatTime } from "@/util/call";

interface MessageActivityItemProps {
  message: Message;
  conversationId?: string;
}

const MessageActivityItem: React.FC<MessageActivityItemProps> = ({ message, conversationId }) => {
  const navigate = useNavigate();

  const openInThread = () => {
    if (conversationId) {
      navigate(`/inbox/${conversationId}?item=${message.id}`);
    }
  };

  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 hover:bg-accent/50 transition-colors ${conversationId ? "cursor-pointer" : ""}`}
      onClick={conversationId ? openInThread : undefined}
      title={conversationId ? "Show in thread" : undefined}
    >
      <div className="w-8 flex justify-center shrink-0">
        <MessageSquare
          className={`h-4 w-4 ${message.direction === "INBOUND" ? "text-success" : "text-info"}`}
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">
            {message.direction === "INBOUND" ? "Received message" : "Sent message"}
          </span>
          {message.media?.length > 0 && (
            <Image className="h-3.5 w-3.5 text-muted-foreground" />
          )}
        </div>
        {message.body && (
          <p className="text-xs text-muted-foreground truncate">{message.body}</p>
        )}
      </div>
      <span className="text-xs text-muted-foreground shrink-0 tabular-nums">
        {formatTime(new Date(message.createdAt))}
      </span>
    </div>
  );
};

export default MessageActivityItem;
